<!--  -->
<template>
<div >
  <div
    v-show="!showToast"
    class="toggle-button"
    @click="handleToggle"
  >
    <div class="toggle-button__up">
      <div class="toggle-button__up__btn">
        <i
        class="toggle-button__icon" 
        :class="toggleStatus"
        
      ></i>
        <span class="toggle-button__up__btn__text">展开</span>
      </div>
    </div>
    <div class="toggle-button__con">
        <p>题目列表</p>
      </div>
  </div>
  <div
    v-show="showToast"
    class="question-toast" 
    :class="{ 'question-toast-open': showToast}"
    @click.self="handleToggle"
  >
    <div
      class="container"
      :class="toggleContentClass"
    >
    <div
      class="toggle-button"
      :class="{'toggle-button--open': showToast}"
      @click="handleToggle"
    >
      <div class="toggle-button__up">
        <div class="toggle-button__up__btn">
          <i
          class="toggle-button__icon" 
          :class="toggleStatus"
          
        ></i>
          <span class="toggle-button__up__btn__text">收起</span>
        </div>
      </div>
      <div class="toggle-button__con">
        <p>题目列表</p>
      </div>
      
    </div>
      <div class="header" v-show="showToast">
        <span class=" resolve">已作答</span>
        <span class=" current">当前题</span>
        <span class=" unsolved">未作答</span>
      </div>
      <div class="list__container" v-if="bundleList.length > 0 && showToast">
        <div class="list">
          <span
            class="list__item"
            v-for="(item, i) in bundleList"
            :key="i"
            :class="statusClass(item, i)"
            @click="handleClick(item, i)"
          >
            <span class="active" v-if="propCurrentIndex === i">{{ i + 1 }}</span>
            <span v-else>{{ i + 1 }}</span>
          </span>
        </div>
      </div>
      <div class="footer" v-show="showToast">共{{ bundleList.length }}题</div>
    </div>
  </div>
</div>
  
</template>

<script>
export default {
  name: 'QuestionToast',

  props: {
    propCurrentIndex: Number,
    bundleList: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      showToast: true,
      currentIndex: 0,
    };
  },

  computed: {
    toggleStatus() {
      return this.showToast ? 'open' : 'close'
    },
    toggleContentClass() {
      return this.showToast ? 'container-open' : 'container-close'
    },
  },

  methods: {
    handleToggle() {
      this.showToast = !this.showToast
    },
    statusClass({
      correct,
      finish
    }, index) {
      if (finish) return `list__item-resolve ${this.handleCurrentCla(index)}`
      if (!correct) return `list__item-unsolve ${this.handleCurrentCla(index)}`
    },
    handleCurrentCla(index) {
      if (this.propCurrentIndex === index) return 'list__item-current'
      return ''
    },
    handleClick(item, index) {
      // this.propCurrentIndex = index;
      this.$emit('selectIndex', { index })
    }
  }
}

</script>
<style lang='less' scoped>
.toggle-button {
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  width:56px;
  height:132px;
  border-radius:20px 0px 0px 20px;
  z-index: 11;
  cursor: pointer;
  &--open {
    right: 258px;
  }
  &__icon {
    width:16px;
    height:16px;
    border-radius: 100%;
    cursor: pointer;
  }
  &__con{
    position: absolute;
    top:0;
    left:0;
    width: 100%;
    height: 100%;
    background:#F7E4BF;
    border:2px solid #EDC372;
    border-radius:20px 0px 0px 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
    z-index: 1;
    border-right: none;
  }
  &__up{
    position: absolute;
    top:50%;
    left:0;
    transform: translate(-88%,-50%);
    width: 20px;
    height: 65px;
    border:2px solid #EDC372;
    border-right:none;
    background:rgba(240,217,173,1);
    border-radius: 20px 0px 0 20px;
    z-index: 2;
    &__btn{
      width: 20px;
      height: 52px;
      padding:2px 0;
      box-sizing: border-box;
      background:#efcb8f ;
      border-radius: 10px;
      position: absolute;
      top:50%;
      left:6px;
      transform: translate(0,-50%);
      display: flex;
      flex-direction: column;
      // justify-content: space-between;
      align-items: center;
    }

  }
  .open {
    background:rgba(255,255,255,1) url('../assets/question_toast_close.png') no-repeat;
    background-size: 7px 12px ;
    background-position: center center;
  }
  .close {
    background:rgba(255,255,255,1) url('../assets/question_toast_close.png') no-repeat;
    background-size: 7px 12px ;
    background-position: center center;
    transform:rotate(180deg);
  }
  span {
    width:18px;
    font-size:10px;
    text-align: center;
    font-family:PingFangSC-Medium,PingFang SC;
    font-weight:500;
    color:rgba(0,0,0,1);
  }
  p{
    width:18px;
    font-weight: 500;
  }
}
.question-toast {
  position: absolute;
  left: 0;
  top: 0;
  display: flex;
  justify-content: flex-end;
  width: 100%;
  height: 100%;
  z-index: 999;
  &-open {
    background:rgba(0,0,0, .4);
  }
  .container {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 0;
    height: 100%;
    background:rgba(255,253,246,1);
    &-open {
      width: 258px;
      // animation: open .3s linear;
    }
    &-close {
      width: 0;
    }
    @keyframes open {
      0% {
        width: 0;
      }
      100% {
        width: 258px;
      }
    }
  }
  
  .header {
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 100%;
    height:42px;
    box-shadow:0px -1px 4px 0px rgba(0,0,0,0.24);
    .item {
      position: relative;
      padding-left: 16px;
      &::before {
        content: '';
        position: absolute;
        left: -2px;
        top: 3px;
        width:16px;
        height:16px;
        border-radius: 100%;
      }
    }
    .resolve {
      .item;
      &::before {
        background:rgba(170,197,84,1);
        border:1px solid rgba(131,162,32,1);
      }
    }
    .current {
      .item;
      &::before {
        left: -4px;
        top: 1px;
        width: 20px;
        height: 20px;
        background: url('../assets/current_question.png') no-repeat;
        background-size: 100% 100%;
      }
    }
    .unsolved {
      .item;
      &::before {
        background:rgba(216,216,216,1);
        border:1px solid rgba(189,189,189,1);
      }
    }
  }
  .list__container {
    flex: 1;
    overflow-y: scroll;
    padding-bottom: 42px;
    .list {
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      align-items: center;
      width: 215px;
      margin: 0 auto;
      .active {
        width: 40px;
        height: 40px;
        line-height: 36px;
        display: inline-block;
        box-sizing: border-box;
        background:rgba(170,197,84,1);
        border: 2px solid #fff;
        border-radius: 100%;
      }
      // padding: 0 22.5px;
    }
    .list__item {
      margin: 20px 11.5px;
      display: flex;
      justify-content: center;
      align-items: center;
      width:46px;
      height:46px;
      line-height: 46px;
      text-align: center;
      font-size: 16px;
      font-family: PingFangSC-Regular,PingFang SC;
      font-weight: 700;
      color:rgba(0,0,0,1);
      border-radius: 100%;
      cursor: pointer;
      &-resolve {
        background:rgba(170,197,84,1);
        border:2px solid rgba(131,162,32,1);
      }
      &-current {
        position: relative;
        background:#83A220 !important;
        border:2px solid rgba(131,162,32,1)!important;
        // box-shadow: 0 0 10px rgba(218,235,162,1);
        &::after {
          content: '';
          position: absolute;
          bottom: 0;
          bottom: -16px;
          left: 0;
          right: 0;
          margin: auto;
          width: 0;
          height: 0;
          border-left: 6px solid transparent;
          border-right: 6px solid transparent;
          border-bottom: 8px solid rgba(131,162,32,1);
        }
        &::before {
          content: '';
          position: absolute;
          left: -5px;
          top: -5px;
          width: 52px;
          height: 52px;
          border: 3px solid #daeba2 !important;
          border-radius: 100%;
        }
      }
      &-unsolve {
        color:rgba(102,102,102,1);
        background:rgba(216,216,216,1);
        border:2px solid rgba(189,189,189,1);
      }
    }
  }
  .footer {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 42px;
    line-height: 40px;
    text-align: center;
    font-size:16px;
    font-family:PingFangSC-Regular,PingFang SC;
    color:rgba(51,51,51,1);
    background:rgba(255,253,246,1);
    box-shadow: 0px 1px 4px 0px rgba(0,0,0,0.22);
  }
}
</style>